export default __webpack_public_path__ + "static/media/gym-res-btn.8e61d4ff.svg";